import type { DbModelTier } from "@/types/db";

export type McpFlagValue = { model_tiers: DbModelTier[] } | null;

/** Whether a resolved mcpFlag value grants access to the given user's model tier. */
export function isMcpEnabledForTier(value: McpFlagValue, tier: DbModelTier): boolean {
  return value !== null && value.model_tiers.includes(tier);
}
